module.exports = __webpack_public_path__ + "img/loginLeft.69703774.png";